import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'policyFilter',
    standalone: false
})
@Injectable({ providedIn: 'root' })
export class PolicyFilterPipe implements PipeTransform {
    transform(policies: any[], searchTerm: string, ...searchProperties: string[]): any[] {
        if (!policies) {
            return policies;
        }

        let filtered = policies;

        function includesSearchTerm(str: string, searchterm: string) {
            return str.toLowerCase().includes(searchTerm.toLowerCase());
        }

        function filter(prop: any, searchTerm: string): boolean {
            if (typeof prop === 'string') {
                return includesSearchTerm(prop, searchTerm);
            } else if (Array.isArray(prop)) {
                return prop.some((p) => filter(p, searchTerm));
            } else if (typeof prop === 'object') {
                return Object.values(prop).some((p) => filter(p, searchTerm));
            } else {
                return false;
            }
        }
        if (!!searchTerm && !!searchProperties) {
            filtered = filtered.filter((x) => {
                let props = searchProperties.map((searchProperty: string) => {
                    let splitProperties = searchProperty.split('.');
                    let res = x;
                    splitProperties.forEach((prop) => {
                        res = res[prop];
                    });
                    return res;
                });

                return props.some((prop: any) => filter(prop, searchTerm));
            });
        }
        return filtered;
    }
}
